import React, { useState } from 'react'
import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../../firebase/Firebase';

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  };

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      await sendPasswordResetEmail(auth, email, {
        url: 'https://vasco-6851a.web.app/login', // Replace with your redirect URL
        handleCodeInApp: false,
      });
      setMessage('Check your email to reset your password.')
      setError('')
    } catch (err) {
      setError(err.message)
      setMessage('')
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          <input
            style={styles.input}
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={handleEmailChange}
          />
          <button style={styles.button} type="submit">Reset Password</button>
        </div>
      </form>
      {message && <p style={styles.message}>{message}</p>}
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  input: {
    margin: '12px',
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box', // Ensures padding doesn't increase width
  },
  button: {
    backgroundColor: '#FFC300',
    width: 400,
    color: '#000000',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: '0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#E5B100',
    }
  },
  message: {
    color: 'green',
  },
  error: {
    color: 'red',
  },
};

export default ForgotPassword
